import 'regenerator-runtime/runtime';
import 'airbnb-js-shims';
import 'core-js/features/symbol';